import { PasswordReqs, passwordReqs } from "./constants";

export const passwordIsValid = (password: string, username?: string) => {
  const result = passwordReqs.filter((req) => !req.reqTest(password, username));
  return result.length === 0;
};

/**
 * Get password requirements that the given password do not meet.
 */
export const getRequirementsNotMet = (password: string, username?: string): PasswordReqs[] =>
  passwordReqs.filter((req) => !req.reqTest(password, username));

/**
 * Get password requirements that the given password meet.
 */
export const getRequirementsMet = (password: string, username?: string): PasswordReqs[] =>
  passwordReqs.filter((req) => req.reqTest(password, username));
